import { createFileRoute } from "@tanstack/react-router";
import { AdminFxDashboard } from "./-components/admin-fx-dashboard";

export const Route = createFileRoute("/(app)/_admin-layout/admin_/fx")({
  component: AdminFxPage,
});

function AdminFxPage() {
  const context = Route.useRouteContext();
  return <AdminFxDashboard accessToken={context.accessToken} />;
}
